/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API Exporter
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AvitoFormatOptionsDto } from './avito-format-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { CronTask } from './cron-task';
// May contain unused imports in some cases
// @ts-ignore
import type { DescriptionTemplateDto } from './description-template-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { ExportFormats } from './export-formats';
// May contain unused imports in some cases
// @ts-ignore
import type { ImageTransformOptionsDto } from './image-transform-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { PriceOptions } from './price-options';
// May contain unused imports in some cases
// @ts-ignore
import type { ProductMappingDto } from './product-mapping-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { ProductServiceType } from './product-service-type';
// May contain unused imports in some cases
// @ts-ignore
import type { RoundingOption } from './rounding-option';
// May contain unused imports in some cases
// @ts-ignore
import type { TitleTemplateDto } from './title-template-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { TransformersEnum } from './transformers-enum';
// May contain unused imports in some cases
// @ts-ignore
import type { TranslateLanguages } from './translate-languages';

/**
 * 
 * @export
 * @interface CreateExportTaskRequestDto
 */
export interface CreateExportTaskRequestDto {
    /**
     * The name of the file
     * @type {string}
     * @memberof CreateExportTaskRequestDto
     */
    'filename': string;
    /**
     * 
     * @type {ExportFormats}
     * @memberof CreateExportTaskRequestDto
     */
    'format': ExportFormats;
    /**
     * 
     * @type {Array<TransformersEnum>}
     * @memberof CreateExportTaskRequestDto
     */
    'transformers': Array<TransformersEnum>;
    /**
     * Force update
     * @type {boolean}
     * @memberof CreateExportTaskRequestDto
     */
    'forceUpdate': boolean;
    /**
     * Hours since the last update
     * @type {number}
     * @memberof CreateExportTaskRequestDto
     */
    'hoursSinceLastUpdate': number;
    /**
     * List of Product IDs
     * @type {Array<number>}
     * @memberof CreateExportTaskRequestDto
     */
    'productIds'?: Array<number>;
    /**
     * Select product sample id
     * @type {number}
     * @memberof CreateExportTaskRequestDto
     */
    'selectProductSampleId'?: number;
    /**
     * 
     * @type {ProductServiceType}
     * @memberof CreateExportTaskRequestDto
     */
    'platform'?: ProductServiceType;
    /**
     * 
     * @type {TranslateLanguages}
     * @memberof CreateExportTaskRequestDto
     */
    'language'?: TranslateLanguages;
    /**
     * Trade types to exclude
     * @type {Array<number>}
     * @memberof CreateExportTaskRequestDto
     */
    'excludeTradeTypes'?: Array<number>;
    /**
     * Price options
     * @type {Array<PriceOptions>}
     * @memberof CreateExportTaskRequestDto
     */
    'priceOptions'?: Array<PriceOptions>;
    /**
     * Выгрузка без цен: источник цен не опрашивается, в фид попадают только каталожные данные товара, цены/SKU пустые (price 0).
     * @type {boolean}
     * @memberof CreateExportTaskRequestDto
     */
    'withoutPrices'?: boolean;
    /**
     * Округление итоговой цены (применяется после наценки и свёртки вариантов). zeros — число нулей в конце (шаг 10^zeros), direction — nearest/ceil/floor. Приоритетнее устаревшего трансформера ROUNDING_PRICE.
     * @type {RoundingOption}
     * @memberof CreateExportTaskRequestDto
     */
    'roundingOption'?: RoundingOption;
    /**
     * Cron task
     * @type {CronTask}
     * @memberof CreateExportTaskRequestDto
     */
    'cronTask'?: CronTask;
    /**
     * Параметры watermark для IMAGE_TRANSFORM
     * @type {ImageTransformOptionsDto}
     * @memberof CreateExportTaskRequestDto
     */
    'imageTransformOptions'?: ImageTransformOptionsDto;
    /**
     * Карта маппинга параметров товара под целевой формат. Format-specific правила (whitelist target-ключей, required onMiss) проверяются через ZodValidationPipe — см. ConvertRequestGuard.
     * @type {ProductMappingDto}
     * @memberof CreateExportTaskRequestDto
     */
    'mapping'?: ProductMappingDto;
    /**
     * Опции, специфичные для Avito-фида. Conditional-required для format===Avito проверяется через ZodValidationPipe.
     * @type {AvitoFormatOptionsDto}
     * @memberof CreateExportTaskRequestDto
     */
    'avitoOptions'?: AvitoFormatOptionsDto;
    /**
     * Шаблон для перезаписи title (составное название). Whitelist плейсхолдеров — на GET /export/template-variables. Семантическая валидация (синтаксис + whitelist + длины) — через ZodValidationPipe.
     * @type {TitleTemplateDto}
     * @memberof CreateExportTaskRequestDto
     */
    'titleTemplate'?: TitleTemplateDto;
    /**
     * Шаблон для перезаписи description (главный сценарий — заполнение товаров с пустым описанием через applyOnlyIfEmpty + fallback).
     * @type {DescriptionTemplateDto}
     * @memberof CreateExportTaskRequestDto
     */
    'descriptionTemplate'?: DescriptionTemplateDto;
    /**
     * Стратегия свёртки вариантов одного товара (productId) в один offer. min — вариант с минимальной положительной ценой, max — с максимальной, avg — среднее по группе (округлено). Undefined = без свёртки (один offer на каждый variantId).
     * @type {string}
     * @memberof CreateExportTaskRequestDto
     */
    'collapseVariantsByProductId'?: CreateExportTaskRequestDtoCollapseVariantsByProductIdEnum;
}

export const CreateExportTaskRequestDtoCollapseVariantsByProductIdEnum = {
    Min: 'min',
    Max: 'max',
    Avg: 'avg'
} as const;

export type CreateExportTaskRequestDtoCollapseVariantsByProductIdEnum = typeof CreateExportTaskRequestDtoCollapseVariantsByProductIdEnum[keyof typeof CreateExportTaskRequestDtoCollapseVariantsByProductIdEnum];


